import { render, staticRenderFns } from "./Building3DModel.vue?vue&type=template&id=6142750a"
import script from "./Building3DModel.vue?vue&type=script&lang=js"
export * from "./Building3DModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports